import { useDispatch } from 'react-redux';
import { isFeatureActive } from '@helpers';
import { Badge } from 'palette/Badge';
import { Button } from 'palette/Button';
import { useFavoritesCount } from '@common/Favorites/hooks/useFavoritesCount';
import GlobalSearchHeaderContainer from '@common/GlobalSearch/containers/GlobalSearchHeaderContainer';
import { useConfig } from '@common/Hooks/useConfig';
import useRouteFormatter from '@common/Hooks/useRouteFormatter';
import { useTranslation } from '@common/Hooks/useTranslation';
import { openFavorites } from '@common/MyLists/store/actions/MyListsActions';
import { useShopcartCount } from '@common/Shopcart/hooks/useShopcartCount';
import { BEMBlock } from '@helpers/classnames';
import { pushToDataLayer } from '@helpers/dataLayer';
import { CUSTOMER_CLUB } from '@routes';

import '../styles/MainHeaderActionBar.scss';

export function MainHeaderActionBar({
    customerDashboardUrl,
    checkoutShopcartUrl,
    theme
}) {
    const translate = useTranslation();
    const config = useConfig();
    const dispatch = useDispatch();
    const formatRoute = useRouteFormatter();
    const favoritesCount = useFavoritesCount();
    const shopcartCount = useShopcartCount();
    const buttonTheme = theme === 'dark' ? 'dark' : 'secondary';
    const [block, BEMElement] = BEMBlock('main-header-action-bar');

    const handleShopcartClick = () => {
        pushToDataLayer({
            event: 'ga_event',
            event_info: {
                category: 'cart',
                action: 'go to cart',
                label: 'cart icon',
                value: null,
                non_interaction: 1
            }
        });
    };

    const handleFavouritesClick = () => dispatch(openFavorites());

    return (
        <div className={block}>
            <GlobalSearchHeaderContainer
                customClass={BEMElement('search')}
                theme={theme}
            />
            <Button
                isTransparent
                ariaLabel={translate('customer.club.profile.account.header')}
                href={customerDashboardUrl}
                iconName="palette_profile"
                theme={buttonTheme}
            />
            {isFeatureActive('PLT-11257_boozt_club', config) && (
                <Button
                    isTransparent
                    ariaLabel="Club"
                    className={BEMElement('club')}
                    href={formatRoute(CUSTOMER_CLUB)}
                    iconName="palette_club"
                    theme={buttonTheme}
                />
            )}
            {isFeatureActive('product.detail.favorites', config) && (
                <Button
                    isTransparent
                    ariaLabel={translate('My_favorites_tab')}
                    className={BEMElement('favorites')}
                    iconName="palette_heart"
                    theme={buttonTheme}
                    onClick={handleFavouritesClick}
                >
                    <Badge
                        className={BEMElement('favorites-badge')}
                        label={favoritesCount}
                        size="s"
                        theme="light"
                    />
                </Button>
            )}
            <Button
                isTransparent
                ariaLabel={translate('checkout.add_to_cart_feedback.go_to_cart_btn')}
                className={BEMElement('shopcart')}
                href={checkoutShopcartUrl}
                iconName="palette_cart"
                theme={buttonTheme}
                onClick={handleShopcartClick}
            >
                <Badge
                    className={BEMElement('shopcart-badge')}
                    label={shopcartCount}
                    size="s"
                    theme="light"
                />
            </Button>
        </div>
    );
}
